import axios from "axios";
import WeatherRoutingAuthenticationService from "./authentication/service";

const authenticationService = new WeatherRoutingAuthenticationService(
  process.env.VUE_APP_LOCAL_WR_API_URL
);

const weatherRoutingAxiosInstance = axios.create({
});

weatherRoutingAxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const response = await authenticationService.refreshToken();
      originalRequest.headers["theyr-token"] = response["access_token"];
      return weatherRoutingAxiosInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default weatherRoutingAxiosInstance;
